import React from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import ShirtProduct from '../../component/Product/shirt'
import Actions from '../../redux/action'
import { Collection } from '../../config/constant'
import { GET_COLLECTION_LIST } from '../../Queries/collection'

class Shirt extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            perPage: 50,
            sortBy: "BEST_SELLING"
        }
    }
    componentDidMount() {
        const { sortBy, perPage } = this.state
        let query = GET_COLLECTION_LIST(Collection.plp, perPage, sortBy, false)
        this.props.getPLPList(query)
    }
    render() {
        const { plpList } = this.props.getPLP || {}
        const { collectionByHandle } = (plpList && plpList.data) || {}
        return (
            <React.Fragment>
                <ShirtProduct collections={collectionByHandle} />
            </React.Fragment>
        )
    }
}

const mapStateToProp = (state) => {
    return {
        getPLP: Actions.getPLP(state)
    }
}

export default withRouter(connect(mapStateToProp, {
    getPLPList: Actions.getPLPList
})(Shirt));
